import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import USER_ROLE from 'constants/role';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';
import { selectHideCashup, selectHideDetails, selectHideStock } from 'selectors/user';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('TooltipForReceptionist');

const TooltipPermissions = ({ tooltipClass }) => {
  const componentRef = useRef(null);
  const { val: isOpen, yay: open, nay: close } = useTip(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (ev) => {
      const element = componentRef.current;
      if (element && element.contains(ev.target)) return;
      close();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [close]);

  return (
    <div
      className={cn({
        'tooltip-permissions': true,
        [tooltipClass]: tooltipClass,
      })}
      ref={componentRef}
      onClick={open}
      role="button"
      tabIndex="0"
    >
      {isOpen && (
        <div className="pink-area">
          <span
            className="tooltip-text"
            role="img"
            aria-labelledby={t('composite.tooltipForReceptionalist.managerAccess')}
          >
            🚫 {t('composite.tooltipForReceptionalist.managerAccess')} 🚫
          </span>
        </div>
      )}
    </div>
  );
};

const TooltipForReceptionist = ({
  where = '',
  userRole,
  checkCashup,
  hideCashup,
  checkStock,
  hideStock,
  checkDetails,
  hideDetails,
  replacement = null,
}) => {
  if (userRole !== USER_ROLE.receptionist) return replacement;
  if (checkCashup && hideCashup !== true) return replacement;
  if (checkStock && hideStock !== true) return replacement;
  if (checkDetails && hideDetails !== true) return replacement;

  const tooltipClass = fromAnyToString(where).trim();
  if (where && !tooltipClass) {
    // notify in console that we may have missed a location
    L.warn('()', 'problem with class', where, 'converted to', tooltipClass);
  }

  return <TooltipPermissions tooltipClass={tooltipClass} />;
};

const TooltipForReceptionistHoc = connect((state) => ({
  hideCashup: selectHideCashup(state),
  hideDetails: selectHideDetails(state),
  hideStock: selectHideStock(state),
  userRole: selectEffectiveUserRole(state),
}))(TooltipForReceptionist);

export default TooltipForReceptionistHoc;
